import { TableRow, TableCell } from "@mui/material";

export default function TableEmptyRows({ emptyRows, height }: any) {
  if (!emptyRows) {
    return null;
  }

  return (
    <TableRow
      sx={{
        ...(height && {
          height: height * emptyRows,
        }),
      }}
    >
      <TableCell colSpan={9} />
    </TableRow>
  );
}
